import React, { Component } from 'react'
import X46MK2ConfiguratorImage from './X46MK2ConfiguratorImage'
import OverlayImageStack from '../OverlayImageStack'

export default class X46MK2ConfiguratorImageWithOverlays extends Component {
  constructor (props) {
    super(props)
    this.state = { overlayUrls: [] }
    this.handleOverlayUrls = this.handleOverlayUrls.bind(this)
  }

  handleOverlayUrls (urls) {
    const current = this.state.overlayUrls
    if (urls.length !== current.length || urls.some((u, i) => u !== current[i])) {
      this.setState({ overlayUrls: urls })
    }
  }

  render () {
    return (
      <div style={{ position: 'relative' }}>
        <X46MK2ConfiguratorImage
          {...this.props}
          onOverlayUrls={this.handleOverlayUrls}
        />
        <OverlayImageStack urls={this.state.overlayUrls} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2ConfiguratorImageWithOverlays.js